import ProjectInfoHistory from 'components/project/ProjectInfoHistory';
import useFetchLoading from 'lib/hooks/useFetchLoading';
import useInput from 'lib/hooks/useInput';
import { OffsetPagingData } from 'lib/types/sharedTypes';
import { useDidUpdateEffect } from 'lib/utils';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ProjectActions } from 'store/actionCreators';
import { useShallowAppSelector } from 'store/hooks';

interface ProjectInfoHistoryProps {
  isClinic?: boolean;
  isOpen: boolean;
  onClick: () => void;
}

interface projectHistory {
  enrollDate: number;
  title: string;
  type: string;
  updaterSyncUid: string;
  _id: string;
  params?: {
    param1?: string;
    param2?: string;
    param3?: string;
    param4?: string;
    param5?: string;
    param6?: string;
    // userGroupCode?: string;
    content?: string;
  };
}

function ProjectInfoHistoryContainer({
  isClinic = false,
  isOpen,
  onClick,
}: ProjectInfoHistoryProps) {
  const {
    language,
    projectHistoriesData: { list: projectHistoryList, pagingData: projectHistoryPagingData },
    fetchProjectHistoriesSuccess,
  }: {
    language: string;
    projectHistoriesData: { list: projectHistory[]; pagingData: OffsetPagingData };
    fetchProjectHistoriesSuccess: boolean;
  } = useShallowAppSelector(state => ({
    language: state.base.language,
    projectHistoriesData: state.project.projectHistories.data || {},
    fetchProjectHistoriesSuccess: state.project.projectHistories.success,
  }));

  const { pcode } = useParams() as { pcode: string };
  const projectCode = pcode;
  const page = useInput(1);
  const [projectHistoryListCt, setProjectHistoryListCt] = useState<projectHistory[]>([]);
  const { isFetchSuccess } = useFetchLoading({ fetchProjectHistoriesSuccess });
  const historyInfoRef = useRef<HTMLDivElement>(null);

  // SECTION: init
  useEffect(() => {
    ProjectActions.fetch_project_histories_request({
      id: projectCode,
      data: { page: page.value },
    });
  }, []);

  useDidUpdateEffect(() => {
    if (!fetchProjectHistoriesSuccess) return;

    if (page.value === 1) {
      setProjectHistoryListCt(projectHistoryList);
    } else {
      setProjectHistoryListCt(draft => [...draft, ...projectHistoryList]);
    }
  }, [fetchProjectHistoriesSuccess]);

  useEffect(() => {
    if (!isOpen) return;

    function handleClickOutside(event: MouseEvent) {
      if (historyInfoRef.current && !historyInfoRef.current.contains(event.target as Node)) {
        onClick();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [historyInfoRef, isOpen]);

  const handleFetchHistoryList = () => {
    ProjectActions.fetch_project_histories_request({
      id: projectCode,
      data: { page: page.value + 1 },
    });
    page.setValue((draft: number) => draft + 1);
  };

  return (
    <ProjectInfoHistory
      isOpen={isOpen}
      onClick={onClick}
      language={language}
      projectHistoryList={projectHistoryListCt}
      projectHistoryPagingData={projectHistoryPagingData}
      page={page}
      historyInfoRef={historyInfoRef}
      isFetchSuccess={isFetchSuccess}
      // onChangePage={handleChangePage}
      onFetchHistoryList={handleFetchHistoryList}
      isClinic={isClinic}
    />
  );
}

export default React.memo(ProjectInfoHistoryContainer);
